import React, { Component } from 'react'
import MyNavbar from "../../components/Navbar/MyNavbar";
import Status from '../../components/Ticket/TicketStatusDetail/Status'
export default class TicketStatusDetailPage extends Component {
    
    render() {
        return (
            <div>
                 <MyNavbar />
                 <Status />
            </div>
        )
    }
}
